/** Plan z cennika Booking (room.pricing) */
export interface IBookingPricingPlanLite {
  booking_id?: string | number
  is_child?: number | string
  id_parent?: string | number
}

export function isBookingDependentPlan(
  plan: IBookingPricingPlanLite | undefined,
): boolean {
  return plan != null && Number(plan.is_child) === 1
}

/** Tekst prowizji / różnicy dla planu zależnego (jak w starym branchu per-pokój). */
export function formatBookingDependentProvision(
  integration:
    | {
        price_change_amount?: unknown
        price_change_type?: unknown
        price?: unknown
      }
    | undefined,
  currency: string,
  adjustPrice: (v: string | number) => string,
): string {
  if (!integration) return '0%'
  const typ = integration.price_change_type
  const isPercent =
    typ === '0' || typ === 0 || String(typ) === '0' || typ === undefined

  if (!isPercent) {
    const raw = integration.price_change_amount
    const price =
      raw !== undefined &&
      raw !== null &&
      raw !== '' &&
      Number(raw) !== 0
        ? Number(raw)
        : integration.price &&
          integration.price !== '0.00' &&
          integration.price !== 0 &&
          integration.price !== '0'
        ? Number(integration.price)
        : null
    if (price == null || Number.isNaN(price)) return ''
    const abs = Math.abs(price)
    return `${price > 0 ? '+' : ''}${adjustPrice(String(abs))} ${currency}`
  }

  const rawAmt = Number(integration.price_change_amount ?? 0)
  if (!rawAmt && rawAmt !== 0) return '0%'
  const s = String(Math.abs(rawAmt)).replace('.', ',') + '%'
  if (rawAmt > 0) return '+' + s
  if (rawAmt < 0) return '-' + s
  return '0%'
}
